import React, { useEffect, useState, useRef } from 'react'
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik, useFormikContext } from 'formik';
import { connect } from 'react-redux';
import { userPaymentInfo } from "../../../services/addressService";
import {  faMoneyBillWave} from '@fortawesome/free-solid-svg-icons'
import * as actions from '../../../store/actions/cart';
import Stepper from '../../Stepper/index';
import Button from 'react-bootstrap/Button';
import { isEmpty } from '../../../validation';
import { phoneRegex } from "../../../validation/validation";
import { faPaypal, } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome'




const PaymentPage = (props) => {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState()
    const [formEmpty, setFormEmpty] = useState(false)
    const fromRef = useRef()
    const previousPage = () => {
        props.history.push("/cart");
        

    }
    const cities = ['Ajax', 'Brampton','Etobicoke','East York','North York', 'Markham', 'Mississauga', 'Oshawa', 'Pickering', 'Richmond Hill', 'Scarborough', 'Toronto', 'Vaghaun', 'Whitby', 'York']
   
    const defaultFormValue={ name:'', useName:'', phone:'', email:'',  method:'' }
    const [formValue, setFormValue]= useState(defaultFormValue);

    

    const handleSubmit = (value) => {
        if (selectedPaymentMethod) {
            value.method = selectedPaymentMethod
            
            if (props.token) {
                props.addPayment(value)
                
                window.sessionStorage.setItem("key", JSON.stringify(value));
                
                const parsedData=JSON.parse(window.sessionStorage.getItem("key"));
                
                setFormValue(parsedData)
                
                
            } else {
                props.addPayment(value)
                window.sessionStorage.setItem("key", JSON.stringify(value));
                
                const parsedData=JSON.parse(window.sessionStorage.getItem("key"));
                
                setFormValue(parsedData)
            }
        }
        props.history.push(window.location.href="/cart/address");
    };
    
    const paymentSchema = Yup.object().shape({
        name: Yup.string()
            .required('Please enter First Name'),
        useName: Yup.string()
            .required('Please enter Last Name'),
        phone: Yup.string()
            .matches(phoneRegex, "Please enter valid contact number")
            .required('Please enter phone number'),
        email: Yup.string()
            .email('Please enter valid email!')
            .required('Please enter email'),
    });

    const paymentCashappSchema = Yup.object().shape({
        name: Yup.string()
            .required('Please enter name'),
        cashTag: Yup.string()
            .email('Please enter valid email!')
            .required('Please enter email'),
        phone: Yup.string()
            .matches(phoneRegex, "Please enter valid contact number")
            .required('Please enter phone number'),
        email: Yup.string()
            .email('Please enter valid email!')
            .required('Please enter email')
            .oneOf([Yup.ref('cashTag'), null], 'Interac email do not match'),
            
    });

    const paymentZelleSchema = Yup.object().shape({
        name: Yup.string()
            .required('Please enter email'),
        phone: Yup.string()
            .matches(phoneRegex, "Please enter valid contact number")
            .required('Please enter phone number'),
        email: Yup.string()
            .email('Please enter valid email!')
            .required('Please enter email'),
    });

    useEffect(() => {
        // if (isEmpty(props.items)) {
        //     props.history.push("/cart");
        // }
    });
    
   
    
    const nextButton = () => {
        if (fromRef.current) {
            fromRef.current.handleSubmit()
        }else{
            setFormEmpty(true)
        }
    }
    
   
    return (
        <div className="container mb-2">
            
        <div className='container-3'>
        <div>
                {
                    props.totalPayment >= 1 &&
                    <Stepper steps={[{ title: "Devices" }, { title: "Payment" }, { title: "Address" }, { title: "Checkout" }]} activeStep={1} />
                }
                {
                    props.totalPayment === 0 &&
                    <Stepper steps={[{ title: "Devices" }, { title: "Address" }, { title: "Checkout" }]} activeStep={0} />
                }
                <hr></hr>
            </div>
            <div className=" ml-2">
                <h6>How would you like to get paid </h6>
                <span style={{fontSize:12, color:"red"}}>Please note: Cash payment option is for the local customer only, Who're willing to meet at public places in following cities of GTA.</span>
                {cities.map((city,index) => {
                   return <button class=" rounded bg-white ml-1 mt-1 border border-dark" key={index}><span style={{fontSize:"15px",fontWeight:600, color:"black", padding:"5px"}}>{city}</span></button>
                })}
                
{          /*      <span style={{fontSize:12, color:"red"}}>If you can't meet in person at above mentioned cities, Please select PayPal or E-transfer as payment method and we will provide you with prepaid shipping label to ship your device(s) to us free of charge.</span>
*/}                
            </div>
            <hr></hr>
            <div className="ml-5 mb-1">
                <h7>Chosse your payment method </h7>
            </div>
         {formEmpty &&<span className="text-danger">Please select the payment method:</span>}
            <div className="row align-content-center">
                <div className="col-md-12">
                    <div className="col-md-14 p-2 bg-white border rounded-lg">
                    <input className="" onClick={() => setSelectedPaymentMethod('Cash')} type="radio" value="Cash" name="method" /> 
                    <div>
                     <div style={{fontSize:"40px", }} className=" ml-2 d-flex">
                        <FontAwesomeIcon className="mb-4 "icon={faMoneyBillWave} />
                        <label className=""style={{fontSize:"22px", fontWeight:600, marginLeft:"5px", marginBottom:"20px"}}>Cash </label>
                    </div>
                    <span style={{fontSize:"16px", color:"red", fontWeight:400}}>*For local customers only, who are willing to meet in above listed cities.</span>
                 </div> 
                   
                    
                   
                        
                        {
                            selectedPaymentMethod === 'Cash' &&
                            <Formik
                               
                                initialValues={{formValue}}                             
                                onSubmit={handleSubmit}
                                validationSchema={paymentSchema}
                                innerRef={fromRef}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        <div className="col-md-12 pl-0 mt-2">
                                        <span className="text-danger">*</span>
                                            <label>
                                                First Name:
                                               </label>
                                            <div>
                                                <Field className="form-control" type="text" name="name"  />
                                                <ErrorMessage name="name" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Last Name:
                                               </label>
                                            <div>
                                                <Field className="form-control" type="text" name="useName" />
                                                <ErrorMessage name="useName" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Phone:
                                               </label>
                                            <div>
                                                <Field className="form-control" type="text" name="phone" placeholder="Asociate will contact you on this for meeting"/>
                                                <ErrorMessage name="phone" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Email :
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="email" />
                                                <ErrorMessage name="email" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        
                                    </Form>
                                )}
                            </Formik>
                        }
                    </div>
                </div>
                <div className="col-md-12 mt-3">
                <div className="col-md-14 p-2 bg-white border rounded-lg">  
                <input className="" onClick={() => setSelectedPaymentMethod('PayPal')} type="radio" value="PayPal" name="method" />
                   
                <div>
                     <div style={{fontSize:"40px", }} className=" ml-2 d-flex">
                        <FontAwesomeIcon className="mb-4 "icon={faPaypal} />
                        <label className=""style={{fontSize:"22px", fontWeight:600, marginLeft:"5px", marginBottom:"20px"}}>PayPal </label>
                    </div>
                 </div>   
                       
                        {
                            selectedPaymentMethod === 'PayPal' && <Formik
                                initialValues={{ name: '', useName: '', phone: '', email: '' }}
                                onSubmit={handleSubmit}
                                validationSchema={paymentSchema}
                                innerRef={fromRef}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        <div className="col-md-12 pl-0 mt-2">
                                       
                                            <label>
                                                First Name:
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="name" />
                                                <ErrorMessage name="name" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                            <label>
                                                Last Name
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="useName" />
                                                <ErrorMessage name="useName" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Phone (If you already have PayPal account provide the same Phone Number registered with PayPal):
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="phone" />
                                                <ErrorMessage name="phone" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                              Email (If you already have PayPal account provide the email registered with PayPal) :
                                               </label>
                                            <div>
                                                <Field className="form-control" type="text" name="email" />
                                                <ErrorMessage name="email" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        }
                    </div>
                </div>

                <div className="col-md-12 mt-3">
                <div className="col-md-14 p-2 bg-white border rounded-lg">  
                    <input className="" onClick={() => setSelectedPaymentMethod('E-transfer')} type="radio" value="E-transfer" name="method" />
                     <div>
                     <div className=''>
                    <img className="w-20 p-1 ml-2" style={{background:''}} src="https://cash4device.s3.ca-central-1.amazonaws.com/payment_method/Interac_Brand_2021.png"></img>
                    <label style={{fontSize:"22px", fontWeight:600, margin:"5px"}}>E-transfer(Interac)</label>
                    </div>
                    
                    
                     </div>  
                       
                        {
                            selectedPaymentMethod === 'E-transfer' && <Formik
                                initialValues={{ name: '', cashTag: '', phone: '', email: '' }}
                                onSubmit={handleSubmit}
                                validationSchema={paymentCashappSchema}
                                innerRef={fromRef}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        <div className="col-md-12 pl-0 mt-2">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Name:
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="name" />
                                                <ErrorMessage name="name" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                       
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Interac Phone Number:
                                                </label>
                                            <div>
                                                <Field className="form-control" type="text" name="phone" />
                                                <ErrorMessage name="phone" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                                Interac Email:
                                             </label>
                                            <div>
                                                <Field className="form-control" type="text" name="cashTag" />
                                                <ErrorMessage name="cashTag" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0">
                                        <span className="text-danger">*</span>
                                            <label>
                                            Confirm  Interac Email :
                                               </label>
                                            <div>
                                                <Field className="form-control" type="text" name="email" />
                                                <ErrorMessage name="email" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        }

                    </div>
                </div>

                
            </div>
            <div className=" mt-4 ml-1 mb-4">
                <div className="mt-4 d-flex">
                    <Button className="w-50 bg-warning border-dark" onClick={previousPage} variant="ml-4"><span style={{fontSize:20, fontWeight:800}}>Previous</span></Button>
                    <Button className="w-50  bg-warning border-dark" onClick={nextButton} variant=" ml-4"><span style={{fontSize:20, fontWeight:800}}>Next</span></Button>
                </div>
            </div>
        </div>

        </div>)
}

const mapStateToProps = state => {
    return {
        method: state.cart.payment.method,
        totalPayment: state.cart.totalPayment,
        token: state.auth.token
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPayment: (value) => dispatch(actions.updateCartPayment(value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);